import { render, staticRenderFns } from "./AMKeyboardAssessories.vue?vue&type=template&id=33383774&scoped=true"
import script from "./AMKeyboardAssessories.vue?vue&type=script&lang=ts"
export * from "./AMKeyboardAssessories.vue?vue&type=script&lang=ts"
import style0 from "./AMKeyboardAssessories.vue?vue&type=style&index=0&id=33383774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33383774",
  null
  
)

export default component.exports